var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#5dd39e",
    opacity: 1,
    "data-original": "#7584f2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30a570",
    d: "M512 256c0-7.502-.323-14.929-.955-22.268L402.061 124.748 128.92 405.699l105.395 105.395c7.149.6 14.381.906 21.684.906C397.385 512 512 397.385 512 256z",
    opacity: 1,
    "data-original": "#4855b7",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce00",
    d: "M256 59.626c-108.454 0-196.374 87.92-196.374 196.374S147.546 452.374 256 452.374c.392 0 .781-.013 1.172-.015l11.771-194.683-11.771-198.035c-.391-.003-.78-.015-1.172-.015z",
    opacity: 1,
    "data-original": "#ffce00",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdba12",
    d: "M256 452.374V59.626c108.454 0 196.374 87.92 196.374 196.374S364.454 452.374 256 452.374z",
    opacity: 1,
    "data-original": "#fdba12",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.141,
    cy: 212.666,
    r: 27.106,
    fill: "#636978",
    opacity: 1,
    "data-original": "#636978"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.859,
    cy: 212.666,
    r: 27.106,
    fill: "#414952",
    opacity: 1,
    "data-original": "#414952",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636978",
    d: "M150.87 299.473c0 19.083 6.006 36.931 16.733 51.819h89.57l8.729-27.701-8.729-24.118z",
    opacity: 1,
    "data-original": "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414952",
    d: "M361.13 299.473H256.31v51.819h88.905c10.218-14.606 15.915-32.291 15.915-51.819z",
    opacity: 1,
    "data-original": "#414952",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6c52",
    d: "M167.603 351.293C185.693 376.4 217.21 393.09 256 393.09c.393 0 .781-.012 1.173-.015l8.729-20.883-8.729-20.898h-89.57z",
    opacity: 1,
    "data-original": "#ff6c52",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff432e",
    d: "M256 393.09c39.42 0 71.281-16.158 89.215-41.797H256z",
    opacity: 1,
    "data-original": "#ff432e",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileIcon);
export default __webpack_public_path__ + "static/media/smile-icon.a556ccbb4b493bc1063c4cc3d17d82e6.svg";
export { ForwardRef as ReactComponent };